import SkeletonElement from "./SkeletonElement";

type ListItemSkeletonProps = {
  rows?: number;
  className?: string;
};

export default function ListItemSkeleton({ rows = 3, className = "" }: ListItemSkeletonProps) {
  return (
    <div className={`space-y-4 ${className}`} data-testid="list-item-skeleton">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex items-center space-x-3">
          <SkeletonElement height="h-10" width="w-10" rounded="rounded-full" />
          <div className="flex-1 space-y-2">
            <SkeletonElement height="h-4" width="w-3/4" />
            <SkeletonElement height="h-3" width="w-1/2" />
          </div>
        </div>
      ))}
    </div>
  );
}
